module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "fig1-1"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "max-height": "100%",
      "width": "auto",
      "max-width": "100%",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "image",
      "src": "images/1_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "fig1-1"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('i', [_vm._v("Figure")]), _vm._v(" "), _c('b', [_c('span', {
    staticClass: "color1"
  }, [_vm._v("1.1")])]), _vm._v(" | "), _c('i', [_vm._v("This boy runs on the beach in the most pure and natural way.")])])])])]), _c('a', {
    attrs: {
      "id": "fig1-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce272f6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap01fig01.vue
// module id = 90
// module chunks = 0